export function fMoney(val, { sign = false } = {}) {
  if (val === null || val === undefined || val === "") return "—";
  // strip leading $ and commas if value comes as string e.g. "$1,234.56"
  if (typeof val === "string") val = val.replace(/[$,]/g, "");
  if (isNaN(val)) return "—";
  const num = Number(val);
  const abs = Math.abs(num);
  const neg = num < 0 ? "-" : sign && num > 0 ? "+" : "";
  let formatted;
  if (abs >= 1_000_000) {
    formatted = "$" + (abs / 1_000_000).toFixed(1) + "M";
  } else if (abs >= 10_000) {
    formatted = "$" + (abs / 1_000).toFixed(1) + "K";
  } else {
    formatted = "$" + abs.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  return neg + formatted;
}

export function fPct(val, { sign = false } = {}) {
  if (val === null || val === undefined || isNaN(val)) return "—";
  const num = Number(val);
  const prefix = sign && num > 0 ? "+" : "";
  return prefix + num.toFixed(2) + "%";
}

export function fRatio(val) {
  if (val === null || val === undefined || isNaN(val)) return "—";
  return Number(val).toFixed(2);
}

export function fCount(val) {
  if (val === null || val === undefined || isNaN(val)) return "—";
  return Number(val).toLocaleString("en-US");
}

export function fPrice(val) {
  if (val === null || val === undefined || isNaN(val)) return "—";
  return Number(val).toFixed(5);
}
